import React, { useEffect, useState } from "react";
import { Button, Box, Typography, LinearProgress, DialogContent, Dialog, DialogTitle, IconButton, DialogActions, TextField, InputAdornment, InputLabel, MenuItem, Select, Chip } from "@mui/material";
import { compound, featuress, placetype, unit, unittypess, updateunit } from "../../../components/Apis";
import "react-calendar/dist/Calendar.css";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import imageCompression from 'browser-image-compression';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Calendar } from 'antd';
import dayjs from 'dayjs'; // ✅ Import dayjs
import isBetween from 'dayjs/plugin/isBetween'; // ✅ Import isBetween plugin
import RequestConfirmation from "../../../components/unitSuccess/Success";
import { useNavigate } from "react-router";
import SuccessPage from './SuccessPage'; // Import the SuccessPage component
import { useLocation } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


dayjs.extend(isBetween); // ✅ Extend dayjs with isBetween

// const steps = [
//   "1",
//   "2",
//   "3",
//   "4",
//   "5",
//   "6",
//   "7",
//   "8",
//   "9",
//   "10",
//   "11",
// ];

const Editnewunit = ({ render }) => {
  const location = useLocation();
  const unitid = location.state?.unitId; // استخراج unitId من state
  const [unittypes, setunittypes] = useState([]);
  const [selectedUnitType, setSelectedUnitType] = useState(null);
  const [placetypes, setplacetypes] = useState([])
  const [selecteplacetype, setSelecteplacetype] = useState(null);
  const [mapUrl, setMapUrl] = useState("");
  const [mapDescription, setMapDescription] = useState(null);
  const [features, setFeatures] = useState([]);
  const [selectedfeatures, setSelectedfeatures] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [images, setImages] = useState([]);
  const [tag, setTag] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [houseRules, setHouseRules] = useState("");
  const [note, setNote] = useState("");
  const [checkInDate, setCheckInDate] = useState("09:00:00");
  const [checkOutDate, setCheckOutDate] = useState("10:00:00");
  const [compounds, setcompounds] = useState([])
  const [compoundItem, setCompoundItem] = useState()
  const [offDays, setOffDays] = useState([])
  const [sliderImages, setSliderImages] = useState([]);
  const [newSliderImages, setNewSliderImages] = useState([]);
  const [ownerEdit, setOwnerEdit] = useState(false)
  console.log("compoundItem", compoundItem)

  // Modify the steps array based on ownerEdit
  const steps = ownerEdit === "Active" ? [
    "1", "2", "3", "4", "5", "6", "7", "8", "9", 
  ] : ["Off Days"];

  const fetchUnit = async () => {
    try {
      const response = await unit(unitid);
      console.log("unit response", response)
      console.log(response)
      setCounts({
        adults: response.adults,
        children: response.children,
        pets: response.pets,
        bedrooms: response.bathrooms,
        beds: response.bed,
        bathrooms: response.bathrooms,
        beachPaths: response.beach_passes,
      });
      setSelectedUnitType(response.unit_type_id)
      setSelecteplacetype(response.place_type_id)
      setMapUrl(response.location_url)
      setMapDescription(response.address)
      setSelectedfeatures(response.features_id.map(Number));
      setStartDate(dayjs(response.available_from).format("D-M-YYYY"));
      setEndDate(dayjs(response.available_to).format("D-M-YYYY"));
      setTitle(response.name)
      setDescription(response.description)
      setHouseRules(response.house_rules)
      setNote(response.note)
      setCompoundItem(response.compound_id)
      setOffDays(response.off_days)
      setSliderImages(response.slider_images)
      setOwnerEdit(response.owner_edit)
      //   setImages(response.images?response.images:[])

    } catch (error) {
      console.error('Error fetching unit:', error);
    }
  };

  const [activeStep, setActiveStep] = useState(0);
  const [counts, setCounts] = useState({
    adults: 0,
    children: 0,
    pets: 0,
    bedrooms: 0,
    beds: 0,
    bathrooms: 0,
    beachPaths: 0,
  });

  const [showPopup, setShowPopup] = useState(false);

  // Duplicate popup for images uploaded before
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);
  const [duplicateMessage, setDuplicateMessage] = useState("");
  // Duplicate popup for images uploaded before //
  const [isSuccess, setIsSuccess] = useState(false); // Track success state
  const navigate = useNavigate()



  // const handleNext = () => {
  //   if (activeStep < steps.length - 1) {
  //     setActiveStep((prev) => prev + 1);
  //   }

  // };


  // Add these handler functions
  const handleSliderImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSliderImages(prev => [...prev, file]);
      // Reset the file input value to allow selecting the same file again
      event.target.value = '';
    }
  };

  const handleDeleteSliderImage = (index) => {
    setSliderImages(prev => {
      const newImages = [...prev];
      // If the image is a File object, revoke its object URL
      if (newImages[index] instanceof File) {
        URL.revokeObjectURL(URL.createObjectURL(newImages[index]));
      }
      return newImages.filter((_, i) => i !== index);
    });
  };


  // Modify handleNext to handle different flows
  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      // If we're on the last step, call handleSubmit instead
      handleSubmit();
    } else {
      // Otherwise proceed with normal step navigation
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };
  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const fetchunittypes = async () => {

    try {
      const response = await unittypess();
      setunittypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchplacetypes = async () => {
    try {
      const response = await placetype();
      console.log(response)
      setplacetypes(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };
  const fetchfeatures = async () => {

    try {


      const response = await featuress();
      console.log("my response", response)
      setFeatures(response)

    } catch (error) {
      console.error('Error fetching unit:', error);

    } finally {
    }
  };
  const fetchcompound = async () => {

    try {
      const response = await compound();
      console.log("setcompounds", response)
      setcompounds(response)
    } catch (error) {
      console.error('Error fetching unit:', error);

    }
  };

  useEffect(() => {
    fetchunittypes()
    fetchplacetypes()
    fetchfeatures()
    fetchUnit()
    fetchcompound()
  }, [])

  // Function to handle numbers of step 4
  const handleCountChange = (type, operation) => {
    setCounts((prevCounts) => ({
      ...prevCounts,
      [type]: operation === 'increment' ? prevCounts[type] + 1 : Math.max(prevCounts[type] - 1, 0),
    }));
  };
  // PopUp never go to next step without selection
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // Function to handle image selection
  const handleImageChange2 = async (event) => {
    const files = Array.from(event.target.files);
    const compressedImages = await Promise.all(files.map(async (file) => {
      try {
        const compressedFile = await imageCompression(file, {
          maxSizeMB: 0.5, // Reduce the maximum size to 0.5 MB
          maxWidthOrHeight: 1280, // Reduce the maximum width or height
          useWebWorker: true,
        });
        return compressedFile;
      } catch (error) {
        console.error('Error compressing image:', error);
        return file; // Fallback to original file if compression fails
      }
    }));

    // Handle the compressed images as needed
    setImages((prevImages) => [...prevImages, ...compressedImages]);
  };

  // Function to remove an image
  const handleRemoveImage = (indexToRemove) => {
    setImages((prevImages) => prevImages.filter((_, index) => index !== indexToRemove));
  };
  // PopUp for images uploaded before
  const handleCloseDuplicatePopup = () => {
    setShowDuplicatePopup(false);
  };

  // ----------------------------- Strat New Calendar

  const onSelect = (value) => {
    const formattedDate = value.format("D-M-YYYY");
    
    if (!startDate) {
      // First click - set start date
      setStartDate(formattedDate);
      setEndDate(null);
    } else {
      // Second click - set end date
      setEndDate(formattedDate);
    }
  };
  
  const dateCellRender = (date) => {
    const formattedStartDate = startDate ? dayjs(startDate, "D-M-YYYY") : null;
    const formattedEndDate = endDate ? dayjs(endDate, "D-M-YYYY") : null;

    if (formattedStartDate && formattedEndDate) {
      if (date.isBetween(formattedStartDate, formattedEndDate, 'day', '[]')) {
        return <div style={{ background: '#cce5ff', height: "100%", width: "100%" }}></div>;
      }
    }
    if (formattedStartDate?.isSame(date, 'day')) {
      return <div style={{ background: '#60A9C6', color: 'white', height: "100%", width: "100%" }}></div>;
    }
    if (formattedEndDate?.isSame(date, 'day')) {
      return <div style={{ background: '#60A9C6', color: 'white', height: "100%", width: "100%" }}></div>;
    }
    return null;
  };
  // Add this to show the selected dates
  const renderSelectedDates = () => {
    return (
      <div style={{ marginTop: "1rem" }}>
        <Typography variant="h6">Selected Dates:</Typography>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", marginTop: "0.5rem" }}>
          {startDate && (
            <Chip
              label={`From: ${startDate}`}
              sx={{ backgroundColor: "#cce5ff" }}
            />
          )}
          {endDate && (
            <Chip
              label={`To: ${endDate}`}
              sx={{ backgroundColor: "#cce5ff" }}
            />
          )}
        </div>
      </div>
    );
  };

  // ----------------------------- End New Calendar
  // ----------------------------- Start New Images
  const handleImageChange = (event, type) => {
    const file = event.target.files[0];
    if (file) {
      if (type === "image") {
        setSelectedImage(file);
        // Reset the file input value to allow selecting the same file again
        event.target.value = '';
      }
    }
  };

  const handleAddToState = () => {
    if (tag && selectedImage) {
      const newEntry = { tag, image: selectedImage };

      setImages((prev) => [...prev, newEntry]);
      setTag(null);
      setSelectedImage(null);
      // setSelectedIcon(null);
    } else {
      alert("Please provide a tag, an image");
    }
  };

  const handleRemoveItem = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };
  // ----------------------------- End New Images
  const handleSubmit = async () => {
    try {
      const formData = new FormData();

      if (ownerEdit !== "Active") {
        // If not active, only submit off days
        offDays.forEach((day, index) => {
          formData.append(`off_days[${index}]`, day);
        });
      } else {
        // Original submit logic for active edit
        formData.append("name", title || "");
        formData.append("description", description || "");
        formData.append("note", note || "");
        formData.append("house_rules", houseRules || "");
        formData.append("available_from", startDate);
        formData.append("available_to", endDate);
        formData.append("unit_type_id", selectedUnitType);
        formData.append("place_type_id", selecteplacetype);
        formData.append("location_url", mapUrl);
        formData.append("address", mapDescription);



        formData.append("adults", counts.adults);
        formData.append("children", counts.children);
        formData.append("pets", counts.pets);
        formData.append("bedrooms", counts.bedrooms);
        formData.append("bed", counts.beds);
        formData.append("bathrooms", counts.bathrooms);
        formData.append("beach_passes", counts.beachPaths);

        // Append each image individually
        // images.forEach((image, index) => {
        //   formData.append(`images[${index}]`, image);
        // });
        images.forEach((unit, index) => {
          formData.append(`images[${index}][tag]`, unit.tag);
          formData.append(`images[${index}][image]`, unit.image);
          // formData.append(`images[${index}][icon]`, unit.icon);
        });

        if (selectedfeatures) {
          selectedfeatures.forEach((feature, index) => {
            formData.append(`features_id[${index}]`, feature);
          });
        }

        // Check-in and check-out dates
        formData.append("check_in", checkInDate || "");
        formData.append("check_out", checkOutDate || "");

        // Add compound_id if required
        formData.append("compound_id", compoundItem || "");

        // Add off days to formData
        offDays.forEach((day, index) => {
          formData.append(`off_days[${index}]`, day);
        });

        // Modify slider images handling
        let newImageIndex = 0;
        sliderImages.forEach((image) => {
          // If the image is a URL (existing image), skip it
          if (typeof image === 'string' && image.startsWith('http')) {
            return;
          }
          // If it's a new image (File object), append it with sequential index
          if (image instanceof File) {
            formData.append(`slider_images[${newImageIndex}]`, image);
            newImageIndex++;
          }
        });
      }

      Swal.showLoading();
      const res = await updateunit(formData, unitid);

      if (res.success) {
        Swal.fire("Success", "Unit Updated Successfully", "success").then(() => {
          navigate("/units");
        });
      } else {
        Swal.fire("Error", res.message || "Failed to Update unit", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Failed to Update unit", "error");
    }
  };

  // Add this function near your other calendar-related functions
  const handleResetDates = () => {
    setStartDate(null);
    setEndDate(null);
  };

  return (

    <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", paddingTop: "4rem", direction: "ltr", backgroundColor: "var(--seco-col)", position: "relative" }}>
      <p style={{ width: '100%', textAlign: "left", fontSize: "24px", fontWeight: "600", marginLeft: "3rem" }}>
        {ownerEdit === "Active" ? "Edit Unit" : "Update Off Days"}
      </p>
      <div className="addSteps"  style={{ width: "60%", marginBottom: "2rem" }}>
      {/* Only show progress bar and step content if active */}
      {ownerEdit === "Active" && (
        <div style={{ width: "100%", marginBottom: "2rem" }}>
          <LinearProgress
            variant="determinate"
            value={((activeStep + 1) / steps.length) * 100}
            sx={{
              height: 12,
              borderRadius: 5,
              backgroundColor: "#D3C1B2",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "var(--pri-col)",
              },
            }}
          />
          <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1, mt: 2, textAlign: "center" }}>
            Step {activeStep + 1} of {steps.length}
          </Typography>
        </div>
      )}



      {/* Show only off days step if not active */}
      {ownerEdit !== "Active" ? (
        <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", marginTop: "1rem" }}>
          <p style={{ fontSize: "32px", fontWeight: "600" }}>Select Off Days</p>
          <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>Select the days when your unit will not be available</p>

          <Calendar
            onSelect={(date) => {
              if (date.isBefore(dayjs(), 'day')) {
                return;
              }
              const formattedDate = date.format("D-M-YYYY");
              setOffDays(prev => {
                if (prev.includes(formattedDate)) {
                  return prev.filter(d => d !== formattedDate);
                } else {
                  return [...prev, formattedDate];
                }
              });
            }}
            dateCellRender={(date) => {
              const formattedDate = date.format("D-M-YYYY");
              if (date.isBefore(dayjs(), 'day')) {
                return <div style={{ background: '#d9d9d9', height: "100%", width: "100%" }}></div>;
              }
              if (offDays.includes(formattedDate)) {
                return <div style={{ background: '#ff4d4f', height: "100%", width: "100%" }}></div>;
              }
              return null;
            }}
            disabledDate={(date) => date.isBefore(dayjs(), 'day')}
          />

          <div style={{ marginTop: "2rem" }}>
            <Typography variant="h6">Selected Off Days:</Typography>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "1rem" }}>
              {offDays?.map((day, index) => (
                <Chip
                  key={index}
                  label={dayjs(day, "D-M-YYYY").format("DD/MM/YYYY")}
                  onDelete={() => {
                    setOffDays(prev => prev.filter(d => d !== day));
                  }}
                  sx={{
                    backgroundColor: '#ff4d4f',
                    color: 'white',
                    '& .MuiChip-deleteIcon': {
                      color: 'white',
                      '&:hover': {
                        color: '#ff7875'
                      }
                    }
                  }}
                />
              ))}
            </div>
          </div>

          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              mt: 3,
              backgroundColor: "var(--pri-col)",
              "&:hover": {
                backgroundColor: "var(--pri-col)",
                opacity: 0.9
              }
            }}
          >
            Update Off Days
          </Button>
        </div>
      ) : (
        // Original step content for active edit
        <>
          
        {/* Step Content */}
        {/* ------------------------------------------   Step 1 */}
        {activeStep === 0 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", marginTop: "1rem" }}>
            <p style={{ 
              fontSize: "clamp(24px, 5vw, 32px)", 
              fontWeight: "600",
              textAlign: "center",
              marginBottom: "1rem"
            }}> Which of these best describes your place?</p>
            <div style={{ 
              width: "100%", 
              height: "auto", 
              display: "flex", 
              flexWrap: "wrap", 
              gap: "1rem",
              justifyContent: "center" // Center items on small screens
            }}>
              {unittypes?.map((ele) => (
                <div
                  key={ele.id}
                  style={{
                    width: "clamp(250px, 30%, 300px)", // Responsive width
                    minHeight: "150px",
                    display: "flex",
                    alignItems: "flex-end",
                    padding: "10px",
                    marginTop: "1rem",
                    cursor: "pointer",
                    borderRadius: "12px",
                    backgroundColor: selectedUnitType === ele.id ? "rgba(96, 169, 198, 0.12)" : "#FFF",
                    border: selectedUnitType === ele.id ? "1px solid #60A9C6" : "1.871px solid #F3EBE8",
                    position: "relative"
                  }}
                  onClick={() => setSelectedUnitType(ele.id)}
                >
                  <p style={{ 
                    fontSize: "clamp(16px, 2.5vw, 20px)", 
                    fontWeight: "400",
                    width: "100%",
                    padding: "0.5rem"
                  }}>
                    <img src={ele.icon} alt="Icon" loading="lazy" style={{ 
                      width: "clamp(16px, 2vw, 20px)", 
                      height: "clamp(16px, 2vw, 20px)", 
                      marginRight: "7px" 
                    }} />
                    {ele.unit_type}
                  </p>
                  {selectedUnitType === ele.id && (
                    <CheckCircleIcon
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        color: "#60A9C6",
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 2 */}
        {/* {activeStep === 1 && (<>
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> What type of place will guests have ?</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              {placetypes?.map((ele) => (
                <div
                  key={ele.id}
                  style={{
                    width: "90%",
                    height: "100px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    padding: "10px",
                    border: "1px solid #F3EBE8",
                    marginTop: "0rem",
                    cursor: "pointer",
                    borderRadius: "8px",
                    backgroundColor: selecteplacetype === ele.id ? "rgba(96, 169, 198, 0.12)" : "#FFF",
                    border: selecteplacetype === ele.id ? "1px solid #60A9C6" : "1px solid #F3EBE8",
                    position: "relative"

                  }}
                  onClick={() => setSelecteplacetype(ele.id)}
                >
                  <p style={{ fontSize: "20px", fontWeight: "400" }}>
                    <img src={ele.icon} alt="Icon" loading="lazy" style={{ width: "20px", height: "20px", marginRight: "5px" }} />{ele.place_type}
                  </p>
                  {selecteplacetype === ele.id && (
                    <CheckCircleIcon
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        color: "#60A9C6",
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                      }}
                    />
                  )}
                  {ele.place_type === "An entire place" && (
                    <p style={{ fontSize: "14px", fontWeight: "400", color: "#667085", marginLeft: "1.6rem" }}>
                      Guests have the whole place to themselves.
                    </p>
                  )}

                  {ele.place_type === "Room" && (
                    <p style={{ fontSize: "14px", fontWeight: "400", color: "#667085", marginLeft: "1.6rem" }}>
                      Guests have their own room in a home, plus access to shared spaces.
                    </p>
                  )}

                  {ele.place_type === "Shared room" && (
                    <p style={{ fontSize: "14px", fontWeight: "400", color: "#667085", marginLeft: "1.6rem" }}>
                      Guests sleep in a room or common area that may be shared with you or others.
                    </p>
                  )}


                </div>
              ))}
            </div>
          </div>
        </>)
        } */}
        {/* ------------------------------------------   Step 3 */}
        {activeStep === 1 && (<>
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> Where's your place located ?</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}> Your address is only shared with guests after they've made a reservation.</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              <TextField
                label="Location Url"
                type="text"
                sx={{ width: '100%' }}
                margin="normal"
                value={mapUrl}
                onChange={(e) => setMapUrl(e.target.value)}
              />
              <TextField
                name="description"
                label="Address"
                type="text"
                sx={{ width: '100%' }}
                margin="normal"
                value={mapDescription}
                onChange={(e) => setMapDescription(e.target.value)}
              />
            </div>
          </div>
        </>)
        }
        {/* ------------------------------------------   Step 4 */}
        {activeStep === 2 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>How many people can stay here?</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "1rem", backgroundColor: "#fff", borderRadius: "5px" }}>
              {Object.entries(counts).map(([key, value]) => (
                <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingInline: "10px" }}>
                  <div>
                    <p style={{ fontSize: "20px", fontWeight: "400" }}>{key.charAt(0).toUpperCase() + key.slice(1)}</p>
                    <p style={{ fontSize: "12px", color: "#615C5A" }}>{key === 'adults' ? 'Age 13+' : key === 'children' ? 'Ages 2-12' : ''}</p>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button onClick={() => handleCountChange(key, 'decrement')} style={{ border: "none", backgroundColor: "transparent", fontWeight: "bold", zIndex: 99 }}>-</button>
                    <span style={{ margin: "0 10px", fontWeight: "bold" }}>{value}</span>
                    <button onClick={() => handleCountChange(key, 'increment')} style={{ border: "none", backgroundColor: "transparent", fontWeight: "bold", zIndex: 99 }}>+</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 5 */}
        {activeStep === 3 && (
          <div style={{ display: "flex", flexDirection: "column", height: "auto", width: "100%", marginTop: "1rem" }}>
            <p style={{ 
              fontSize: "clamp(24px, 5vw, 32px)", 
              fontWeight: "600",
              textAlign: "center",
              marginBottom: "1rem"
            }}> Which of these best describes your place?</p>
            <div style={{ 
              width: "100%", 
              height: "auto", 
              display: "flex", 
              flexWrap: "wrap", 
              gap: "1rem",
              justifyContent: "center" // Center items on small screens
            }}>
              {features?.map((ele) => (
                <div
                  key={ele.id}
                  style={{
                    width: "clamp(250px, 30%, 300px)", // Responsive width
                    minHeight: "150px",
                    display: "flex",
                    alignItems: "flex-end",
                    padding: "10px",
                    marginTop: "1rem",
                    cursor: "pointer",
                    borderRadius: "12px",
                    backgroundColor: selectedfeatures.includes(ele.id) ? "rgba(96, 169, 198, 0.12)" : "#FFF",
                    border: selectedfeatures.includes(ele.id) ? "1px solid #60A9C6" : "1px solid #EAEBEE",
                    position: "relative"
                  }}
                  onClick={() => {
                    setSelectedfeatures((prevSelected) => {
                      if (prevSelected.includes(ele.id)) {
                        return prevSelected.filter(id => id !== ele.id);
                      } else {
                        return [...prevSelected, ele.id];
                      }
                    });
                  }}
                >
                  <p style={{ 
                    fontSize: "clamp(16px, 2.5vw, 20px)", 
                    fontWeight: "400",
                    width: "100%",
                    padding: "0.5rem"
                  }}>
                    <img src={ele.icon} alt="Icon" loading="lazy" style={{ 
                      width: "clamp(16px, 2vw, 20px)", 
                      height: "clamp(16px, 2vw, 20px)", 
                      marginRight: "7px" 
                    }} />
                    {ele.feature}
                  </p>
                  {selectedfeatures.includes(ele.id) && (
                    <CheckCircleIcon
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        color: "#60A9C6",
                        backgroundColor: "#fff",
                        borderRadius: "50%"
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 6 Calendar */}
        {activeStep === 4 && (<>
          <p style={{ fontSize: "32px", fontWeight: "600" }}>Select Available Days</p>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            <Calendar 
              onSelect={onSelect} 
              dateCellRender={dateCellRender} 
              style={{ borderRadius: "12px", overflow: "hidden" }}
            />
            {renderSelectedDates()}
            {(startDate || endDate) && (
              <Button
                onClick={handleResetDates}
                variant="outlined"
                startIcon={<DeleteIcon />}
                sx={{
                  alignSelf: "flex-start",
                  borderColor: "#60A9C6",
                  color: "#60A9C6",
                  '&:hover': {
                    borderColor: "#4a8ba3",
                    backgroundColor: "rgba(96, 169, 198, 0.04)"
                  }
                }}
              >
                Reset Selection
              </Button>
            )}
          </div>
        </>)}
        {/* ------------------------------------------   Step 7 of days */}
        {activeStep === 5 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Select Off Days</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>Select the days when your unit will not be available</p>

            <Calendar
              onSelect={(date) => {
                // Don't allow selection of past dates
                if (date.isBefore(dayjs(), 'day')) {
                  return;
                }
                const formattedDate = date.format("D-M-YYYY"); // Format as DD-MM-YYYY
                setOffDays(prev => {
                  if (prev.includes(formattedDate)) {
                    return prev.filter(d => d !== formattedDate);
                  } else {
                    return [...prev, formattedDate];
                  }
                });
              }}
              dateCellRender={(date) => {
                const formattedDate = date.format("D-M-YYYY");

                // Gray out past dates
                if (date.isBefore(dayjs(), 'day')) {
                  return <div style={{ background: '#d9d9d9', height: "100%", width: "100%" }}></div>;
                }

                // Red for selected off days
                if (offDays.includes(formattedDate)) {
                  return <div style={{ background: '#ff4d4f', height: "100%", width: "100%" }}></div>;
                }
                return null;
              }}
              disabledDate={(date) => date.isBefore(dayjs(), 'day')} // Disable past dates
            />

            {/* Display selected off days */}
            <div style={{ marginTop: "2rem" }}>
              <Typography variant="h6">Selected Off Days:</Typography>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "1rem" }}>
                {offDays.map((day, index) => (
                  <Chip
                    key={index}
                    label={dayjs(day, "D-M-YYYY").format("DD/MM/YYYY")}
                    onDelete={() => {
                      setOffDays(prev => prev.filter(d => d !== day));
                    }}
                    sx={{
                      backgroundColor: '#ff4d4f',
                      color: 'white',
                      '& .MuiChip-deleteIcon': {
                        color: 'white',
                        '&:hover': {
                          color: '#ff7875'
                        }
                      }
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 8 upload images with tags*/}
        {/* {activeStep === 6 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem", alignItems: "flex-start" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> Add some photos of your house </p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}> You'll need 5 photos to get started. You can add more or make changes later.</p>
            <TextField
              label="Write a tag..."
              variant="outlined"
              fullWidth
              value={tag}
              onChange={(e) => setTag(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EditIcon />
                  </InputAdornment>
                ),
              }}
            />
            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "3rem", marginBottom: "1rem", marginTop: "1rem" }}>
              <label htmlFor="upload-image" style={uploadStyle}>
                <input
                  type="file"
                  id="upload-image"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, "image")}
                  key={selectedImage ? 'reset' : 'initial'}
                />
                <span style={iconStyle}>Image</span>
              </label>

              <IconButton
                onClick={handleAddToState}
                sx={{
                  // border: '1px solid rgba(0, 0, 0, 0.12)',
                  zIndex: "5",
                  border: '1px dashed var(--pri-col)',
                  borderRadius: "50%",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#fff",
                  }
                }}
              >
                <AddIcon style={{
                  color: "#C47D60", fontSize: "3rem",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#fff",
                  }
                }} />
              </IconButton>
            </div>

            <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", marginBottom: "1rem" }}>
              {selectedImage && (
                <div style={{ position: "relative" }}>
                  <img src={URL.createObjectURL(selectedImage)} alt="Selected Image" style={imgStyle} />
                  <button onClick={() => setSelectedImage(null)} style={removeBtnStyle}>&times;</button>
                </div>
              )}

            </div>


            <div style={{ marginTop: "2rem", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
              {images.map((item, index) => (
                <div key={index} style={{ position: "relative", border: "1px solid #ddd", padding: "10px", borderRadius: "5px" }}>
                  <p style={{ fontWeight: "bold", textAlign: "center" }}>{item.tag}</p>
                  <img src={URL.createObjectURL(item.image)} alt={`upload-${index}`} style={imgStyle} />
                  <button onClick={() => handleRemoveItem(index)} style={removeBtnStyle}>&times;</button>
                </div>
              ))}
            </div>
          </div>
        )} */}
        {/* ------------------------------------------   Step 8 upload Slider images*/}
        {activeStep === 6 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", marginTop: "1rem", alignItems: "flex-start" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}> Add Slider Images </p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>Add images that will appear in the slider on your unit's page.</p>

            {/* Display slider images */}
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", marginTop: "1rem" }}>
              {sliderImages.map((image, index) => (
                <div key={index} style={{ position: "relative" }}>
                  <img
                    src={typeof image === 'string' ? image : URL.createObjectURL(image)}
                    alt={`slider-${index}`}
                    style={{
                      width: "200px",
                      height: "150px",
                      objectFit: "cover",
                      borderRadius: "8px"
                    }}
                  />
                  <IconButton
                    onClick={() => handleDeleteSliderImage(index)}
                    sx={{
                      position: "absolute",
                      top: 5,
                      right: 5,
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                      }
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </div>
              ))}
            </div>

            {/* Add new slider image */}
            <div style={{ marginTop: "2rem" }}>
              <label htmlFor="slider-image-upload" style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                border: "2px dashed #60A9C6",
                borderRadius: "8px",
                padding: "1rem",
                width: "200px",
                height: "150px"
              }}>
                <input
                  type="file"
                  id="slider-image-upload"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={handleSliderImageUpload}
                />
                <AddIcon style={{ color: "#60A9C6", fontSize: "2rem" }} />
              </label>
            </div>
          </div>
        )}

        {/* ------------------------------------------   Step 9 */}
        {activeStep === 7 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Add a title for your house</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}>Short titles work best. You can always change it later.</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1rem" }}>
              <TextField
                label="Write a title..."
                variant="outlined"
                fullWidth
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </div>
          </div>
        )}
        {/* ------------------------------------------   Step 10 */}
        {activeStep === 8 && (
          <div style={{ display: "flex", flexDirection: "column", width: "100%", height: "70vh", marginTop: "1rem" }}>
            <p style={{ fontSize: "32px", fontWeight: "600" }}>Create your description</p>
            <p style={{ fontSize: "16px", fontWeight: "500", color: "#615C5A" }}> Share what makes your place special.</p>
            <div style={{ width: "100%", height: "auto", display: "flex", flexDirection: "column", gap: "1rem", marginTop: "1rem" }}>
              <TextField
                label="Write a description..."
                variant="outlined"
                fullWidth
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Write a House Roules..."
                variant="outlined"
                fullWidth
                value={houseRules}
                onChange={(e) => setHouseRules(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Write a Note..."
                variant="outlined"
                fullWidth
                value={note}
                onChange={(e) => setNote(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EditIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <InputLabel
                sx={{
                  backgroundColor: "white",
                  px: 1, // Padding left and right to cover the border
                  "&.Mui-focused": {
                    backgroundColor: "white",
                  }
                }}>Compounds</InputLabel>
              <Select
                name="compound_id"
                value={compoundItem} // The value will be the selected compound's ID
                onChange={(e) => setCompoundItem(e.target.value)} // Set the selected compound id
              >
                {compounds.length > 0 ? (
                  compounds.map((type, index) => (
                    <MenuItem key={index} value={type.id}> {/* `value` is the compound id */}
                      {type.compound} {/* Displaying the compound name */}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No compounds available</MenuItem> // Fallback message when no compounds
                )}
              </Select>
            </div>
          </div>
        )}


        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3, backgroundColor: "var(--seco-col)" }}>
          <Button
            onClick={handleBack}
            disabled={activeStep === 0}
            sx={{
              backgroundColor: "var(--pri-col)",
              color: "white",
              px: 4,
              '&:hover': {
                backgroundColor: "#8b3e2a",
              }
            }}
          >
            Back
          </Button>
          <Button
            onClick={handleNext}
            sx={{
              backgroundColor: "var(--pri-col)",
              color: "white",
              px: 4,
              '&:hover': {
                backgroundColor: "#8b3e2a",
              }
            }}
          >
            {activeStep === steps.length - 1 ? "Submit" : "Next"}
          </Button>
        </Box>
        </>
      )}
      </div>

      <Dialog open={showPopup} onClose={handleClosePopup} dir="rtl">
        <DialogTitle>{"Can't move to the next step Without selected properties"}</DialogTitle>
        <DialogActions sx={{ justifyContent: "center" }}> {/* Center the button */}
          <Button
            onClick={handleClosePopup}
            sx={{ backgroundColor: "var(--pri-col)", color: "white", "&:hover": { backgroundColor: "#A86950" } }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showDuplicatePopup} onClose={handleCloseDuplicatePopup} sx={{ direction: "rtl", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <DialogContent >
          <Typography>{duplicateMessage}</Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button onClick={handleCloseDuplicatePopup}
            sx={{ backgroundColor: "#C47D60", color: "white", "&:hover": { backgroundColor: "#A86950" } }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <img src="../../assets/image 2 (1).png" style={{ width: "250px", height: "250px", position: "absolute", top: "0px", right: "0px", zIndex: "1", transform: "rotate(0deg)", }} />

      {isSuccess && (
        <SuccessPage /> // Render the SuccessPage component
      )}

    </div>


  );
};

const uploadStyle = { cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", border: "10px dashed #60A9C6", borderRadius: "50%", width: "150px", height: "150px", position: "relative" };
const iconStyle = { fontSize: "20px", color: "#60A9C6", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
const buttonStyle = { padding: "10px 20px", background: "var(--pri-col)", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" };
const imgStyle = { width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" };
const iconImgStyle = { width: "50px", height: "50px", objectFit: "cover", borderRadius: "5px", marginLeft: "10px" };
const removeBtnStyle = { position: "absolute", top: "5px", right: "5px", backgroundColor: "rgba(0, 0, 0, 0.5)", color: "white", border: "none", borderRadius: "50%", width: "20px", height: "20px", cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center" };

export default Editnewunit;
